/**
 * @generated SignedSource<<19ef8c37b4c931911ab2b69eec592502>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "companyId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "companyId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CompanyDetailsPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "admin_company",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "CompanyInfoPanel_company"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "CompanySidebar_company"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CompanyDetailsPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "admin_company",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestampId",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeServices",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6c2fe59f41b70d167532c4fdb1f91619",
            "id": null,
            "metadata": {},
            "name": "CompanyDetailsPageQuery",
            "operationKind": "query",
            "text": "query CompanyDetailsPageQuery(\n  $companyId: ID!\n) {\n  admin_company(id: $companyId) {\n    ...CompanyInfoPanel_company\n    ...CompanySidebar_company\n    id\n  }\n}\n\nfragment CompanyInfoPanel_company on Company {\n  timestampId\n}\n\nfragment CompanySidebar_company on Company {\n  activeServices\n}\n"
        }
    };
})();
node.hash = "1efac490357ae6148aec33a11dac1d5a";
export default node;
